import React, { useEffect, useState } from "react";
import { ReactComponent as PenNPaper } from "../../assets/analyse/PenNPaper.svg";
import { ReactComponent as Cherry } from "../../assets/analyse/Cherry.svg";
import { ReactComponent as Circle } from "../../assets/analyse/Circle.svg";
import { ReactComponent as Spark } from "../../assets/analyse/Spark.svg";
import { ReactComponent as Truck } from "../../assets/analyse/Truck.svg";
import { ReactComponent as Box } from "../../assets/analyse/Box.svg";
import "react-widgets/styles.css";
import AnalysisStep from "./AnalysisStep";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import ModificationLine from "./ModificationLine";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

const AnalysisLine = ({
  item,
  changable,
  quantity,
  quantityUnit,
  totalScore,
  impact_factors,
  checked,
  icon,
  conversion_factor,
  width,
  columns,
  step,
  line_index,
  flow_id,
  color,
  is_reduce,
  loss,
  raw_to_cooked,
  is_dummy,
  k_type,
  description
}) => {
  const [modifying, setModifying] = useState("");
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.screenX;
    setScrollPosition(scrollPosition + position);
  };

  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  var widthvalue = width - 29.5;
  width -= 30;

  function geticon(icon) {
    switch (icon) {
      case "K_Ingredients":
        return <Cherry height={15} />;
      case "K_Cooking":
        return <Cherry height={15} />;
      case "K_Packaging":
        return <Box height={15} fill={"#bdc4cb"} />;
      case "K_Transports":
        return <Truck height={15} fill={"#bdc4cb"} />;
      case "K_Energies":
        return <Spark height={15} fill={"#bdc4cb"} />;
      case "K_Wastes":
        return <Cherry height={15} />;
      case "K_Food_Given":
        return <Cherry height={15} />;
      default:
        return <Circle height={15} />;
    }
  }

  const [modIndex, setModIndex] = useState("da32f256-618d-4bec-a8d9-205817788b26");

  return (
    <>
      {/* {modifying ? (<ModificationLine icon={icon} item={item} data={changable} modifying={modifying} setModifying={setModifying} width={width}/>) : null} */}
      {modifying ? (
        <ModificationLine
          changable={changable}
          icon={icon}
          item={item}
          data={step > 2 ? changable : changable[flow_id]}
          flow_id={flow_id}
          modifying={modifying}
          setModifying={setModifying}
          width={width}
          step={step}
          line_index={line_index}
          imapct_factors={impact_factors}
          quantity={quantity}
          quantityUnit={quantityUnit}
          columns={columns}
          modIndex={modIndex}
          setModIndex={setModIndex}
          loss={loss}
          raw_to_cooked={raw_to_cooked}
          k_type={k_type}
          description={description}
        />
      ) : null}

      <div
        className={`h-[40px] w-max flex justify-start ${is_reduce ? "" : "ml-[30px] "} ${
          modifying != 0 ? "bg-white border-gray-500 border-[1px] rounded" : color ? (color === "green" ? "bg-green-500/25" : "bg-yellow-400/25") : "bg-[#F8FAFB] border-[#F3F5F7] border-[0.1px]"
        } ${color ? (color === "green" ? "hover:bg-green-300/25" : "hover:bg-yellow-300/25") : "hover:bg-white border-[#F3F5F7] border-[0.1px]"}   items-center`}
      >
        <div style={{ width: widthvalue }} className={"w-[" + `${width}` + "px] h-[40px] flex justify-between items-center"}>
          <div className="flex justify-center items-center ml-[20px]">
            {geticon(icon)}
            <div className="flex flex-row">
              <p className="font-Poppins-Regular text-xs whitespace-normal">{item + " "}</p>
              {is_dummy && (
                <Link
                  state={{ display: 5.5 }}
                  to="/Help"
                  // to={{
                  //   pathname: "/Help",
                  //   state: { display: 5.5 },
                  // }}
                  style={{ textDecoration: "underline" }}
                >
                  <p className="font-Poppins-Regular text-xs">{is_dummy ? "(processus vide)" : ""}</p>
                </Link>
              )}
            </div>
          </div>
          {/* {user_info.organization_info.role.access.analyse.write && changable != null ? ( */}
          {!is_reduce && user_info.organization_info.role.access.analyse.write && changable ? (
            <button
              onClick={() => {
                setModifying(!modifying * 1);
              }}
            >
              <PenNPaper height={10} className="mr-[1px]" />
            </button>
          ) : <div className="w-[10px]"/>}
        </div>
      </div>
    </>
  );
};

export default AnalysisLine;
